import PageLayout from '@layouts/PageLayout/PageLayout';
import type { JSX } from 'react';

export function PrivacyPolicyPage(): JSX.Element {
  return <PageLayout>Политика конфиденциальности</PageLayout>;
}
